// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orderState {\n  background-color: #f7f8fa;\n  justify-content: space-between;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
